/** The head's places, in the order they sit. */
export const TABS = [
  ['desk', '/'],
  ['thoughts', '/thoughts'],
  ['plan', '/plan'],
  ['nooks', '/nooks'],
  ['folders', '/folders'],
] as const;

export type Tab = (typeof TABS)[number][0];

/**
 * Which tab a page sits under. A page inside a place keeps its tab lit: an
 * arc is the plan's, a recording or a note is a thought, a nook's file is a
 * nook. A page that belongs to none — writing, connecting — lights nothing.
 */
export function tabFor(path: string): Tab | null {
  if (path === '/nooks' || path === '/spaces' || path === '/workspaces' || path.startsWith('/file/spaces')) {
    return 'nooks';
  }
  if (path === '/thoughts' || path.startsWith('/file/')) return 'thoughts';
  if (path === '/') return 'desk';
  if (path === '/plan' || path.startsWith('/arc/')) return 'plan';
  if (path.startsWith('/folders')) return 'folders';
  return null;
}
